import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../data.service';
import { DocumentCategory } from '../models/declarations';
import { DocumentViewRequest } from '../models/documentViewRequest';
import { MailRequest, MailRequestEx, MailResource } from '../models/mailRequest';
import { PropertyDocumentModel } from '../models/PropertyDocumentModel';
import { DocumentType } from '../models/whatsappRequest';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-propertydocuments',
  templateUrl: './propertydocuments.component.html',
  styleUrls: ['./propertydocuments.component.scss']
})
export class PropertydocumentsComponent implements OnInit {

  constructor(private router: Router, private data:DataService,private datePipe: DatePipe) { }

  ngOnInit(): void {

    this.docs = this.data.SelectedProperty.propertydocuments;
    this.original_docs = this.data.SelectedProperty.propertydocuments;
    this.documentNotes = this.data.SelectedProperty.propertydocumentsnotes;
  }

  public docs : Array<PropertyDocumentModel>;
  private original_docs : Array<PropertyDocumentModel>;
  public searchtext: string = "";
  public documentNotes : string = "";

  onViewDocument(documentid : PropertyDocumentModel){
    
    var req = new DocumentViewRequest();
    req.Document = documentid;
    req.DocType = DocumentType.msgtype_propertydocument;
    this.data.ActiveDocumentViewRequest = req;

    this.router.navigate(['documentviewer'],{skipLocationChange: false});
  }

  onViewPropertyDocumentDetails(doc: PropertyDocumentModel){
    this.data.SelectedPropertyDocument = doc;
    this.router.navigate(['propertydocumentdetails'],{skipLocationChange: false});
  }

  onViewCategory (cat: DocumentCategory){
    this.data.SelectedDocumentCategory = cat;
    this.router.navigate(['propertydocumentscat'],{skipLocationChange: false});
    return false;

  }


  onEmail() : boolean {
    var req: MailRequestEx = new MailRequestEx();
    this.docs.forEach(element => {
      req.MailResources.push({
        Title : element.title,
        URL : element.storagekey,
        ResourceType : "doc"
      });
    });  
    this.data.MailReqEx = req;
    this.router.navigate(['mailprogress']);
    return false;
  }
  onDownload(){
      window.open(this.data.endPoint + "kiosk/propertydocumentsummary?token=" + this.data.token, "_blank");
  }


  onSearchTextChanged() {
    /*
    this.docs = this.original_docs.filter( x => {
      return RegExp('.*' + this.searchtext + '.*',"i").test(this.datePipe.transform(x.documentdate * 1000,"dd/MM/yyyy").toString() + " " + x.title + " " + x.cat.DocumentCategoryName);
    });
    console.log(this.docs.length);
    */

    if (this.searchtext.length === 0){
      this.docs = this.original_docs;
      return;
    }

    this.data.search_request<Array<string>>(
      {
        searchText: this.searchtext,
        cid: this.data.SelectedProperty.id,
        p1: '',
        p2: '',
        p3: '',
        p4: ''
      }, 'POST'
    ).subscribe((v) => {
      this.docs = this.original_docs.filter(
        (e) => {
          return v.find((x) => x === e.id);
        },
      );
    });
  }


  onWhatsapp() : void {

  }

}
